<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="student" slot-scope="student">
          <div class="text-wrap">{{ student.first_name + ' ' + student.last_name }}</div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- View -->
            <a href="javascript:;" class="btn btn-sm btn-info btn-with-addon mr-2"
               @click="showModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fa fa-money" />
              </span>
              Pocket Money
            </a>
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
               @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>

          </div>
        </template>
      </a-table>
    </div>
    <edit-enrollment @onEdited="handleAfteredit"/>
    <pocket-money-modal :data="data"/>
  </div>
</template>

<script>
import editEnrollment from '@/components/hostel/manage/hostel-enrollment/edit'
import pocketMoneyModal from '@/components/hostel/manage/hostel-enrollment/pocketMoneyModal'
const columns = [
  { title: 'Student Code', width: 100, className: 'text-wrap', dataIndex: 'school_enrollment.student_code', scopedSlots: { customRender: 'school_enrollment.student_code' } },
  { title: 'Name', width: 100, className: 'text-left text-wrap', dataIndex: 'student', scopedSlots: { customRender: 'student' } },
  { title: 'Hostel', width: 100, className: 'text-left text-wrap', dataIndex: 'hostel.name', scopedSlots: { customRender: 'hostel.name' } },
  { title: 'Block', width: 100, className: 'text-left text-wrap', dataIndex: 'block.name', scopedSlots: { customRender: 'block.name' } },
  { title: 'Room Number', width: 100, className: 'text-left text-wrap', dataIndex: 'room.room_number', scopedSlots: { customRender: 'room.room_number' } },
  { title: 'Enrollment Date', width: 100, className: 'text-left text-wrap', dataIndex: 'enrollment_date', scopedSlots: { customRender: 'enrollment_date' } },
  { title: 'Remark', width: 100, className: 'text-left text-wrap', dataIndex: 'remark', scopedSlots: { customRender: 'remark' } },
  { title: 'Actions', width: 200, className: 'text-right', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'enrollmentTable',
  components: {
    editEnrollment,
    pocketMoneyModal,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    showModal(record) {
      this.$eventBus.$emit('openModal', record)
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this enrollment?',
        content: `You are about to delete this enrollment.`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/hostel/enrollment/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.student.first_name + ' ' + record.student.last_name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
